import { elementsCategoryId } from './category-ids';

export const unlistedComponentDefinitionComponentIds = [
  // elements
  elementsCategoryId
];
